module.exports = __webpack_public_path__ + "img/kfnImg.b488f035.webp";